import { links, homeLink } from '../common';
import css from './desktop.scss';
import Columns from './components/Columns/Columns';
import { Specs } from '../../experiments';

export default ({ config, mainLinks, socialLinks, t, tAll, experiments }) => `
  <nav class="${css.contentWrapper}" aria-label="${t('nav_aria_label')}">
    <div class="${css.mainContent}">
      ${Columns(mainLinks)}
      <div class="${css.aside}">
        <a
          href="${homeLink(config.language)}"
          class="${css.asideLogo}"
          title="${tAll('title_wix_logo')}"
          tabindex="${config.tabIndex[1]}"
          data-hook="footer-wix-logo"
        >
          Wix.com
        </a>

        ${
          config.language === 'en'
            ? `<p class="${css.asideParagraph}" data-hook="description">${t('short_description')}</p>`
            : `<p class="${css.asideParagraph}" data-hook="description">${t('description')}</p>
               <p class="${css.asideParagraph}" data-hook="closing_line">${t('closing_line1')} ${t(
                'closing_line2',
              )}</p>`
        }
        <p class="${css.asideParagraph}" data-hook="closing_years">${t('closing_years')}</p>
        ${links(
          socialLinks,
          {
            list: css.social,
            item: css.socialItem,
            itemContent: css.socialItemContent,
          },
          null,
          config.tabIndex[1],
        )}
      </div>
    </div>
    ${
      experiments[Specs.EnableLegalLinkUS] === 'true'
        ? `<div class="${css.companyInfoContainer}"><span><a target="_blank" href="https://www.wix.com/about/privacy/do-not-sell-my-personal-information" data-bi-name="do-not-sell-my-personal-information">${t('do_not_sell_personal_data')}</a></span></div>`
        : ''
    }
    ${
      experiments[Specs.EnableCompanyInfoForWixFooterInBrazil] === 'true'
        ? `<div class="${css.companyInfoContainer}"><span>Wix.com Brasil Servicos de internet ltda / CNPJ: 14.644.419/0001-90 /<br>Av. Dr. Yogiro Takaoka, nº 4.384, 5º andar, sala 505 – CEP 06541-038 - Santana de Parnaíba – SP / <a class="${css.companyInfoLink}" target="_blank" href="https://www.wix.com/contact" data-bi-name="contact">Fale com a gente</a></span></div>`
        : ''
    }
  </nav>
`;
